import FullScreenLoader from "../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { Country, State, City } from "country-state-city";

import ThemeSettings from "../Property pages/commun/ThemeSettings"
import { AgentHeader } from "./Commun/AgentHeader"
import AgentSidebar from "./Commun/AgentSidebar"
import { Link } from "react-router-dom"
import { agentPreBooking, agentPrebookingconfirmsave, agentsaveCompanydetail } from "../Services/Service";
import { agentsaveGuestdetail } from "../Services/Service";
import { agentGuestdetail } from "../Services/Service";
import swal from 'sweetalert';

// import { PaymentIframe } from "./PaymentIframe";

export const AgentRoomselect = () => {
  const navigate = useNavigate();
  // const [roomdetails , setRoomDetails] = useState();
  // const [ rateplan , setRatePlan] = useState();
  // const [taxdetails , setTaxDetails] = useState();
  const [guestData, setGuestData] = useState(null);
  const [roomDetails, setRoomDetails] = useState([]);
  const [priceSummary, setPriceSummary] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [extraBeds, setExtraBeds] = useState({});
  const [loading, setLoading] = useState(false);

  // const [paymentUrl, setPaymentUrl] = useState("");


  useEffect(() => {
    const fetchPreBookingData = async () => {
      setLoading(true);
      try {
        const PropertyID = localStorage.getItem("selectedPropertyID");
        const CheckIn = localStorage.getItem("checkInDate");
        const CheckOut = localStorage.getItem("checkOutDate");
        const RoomDetailsRaw = JSON.parse(localStorage.getItem("selectedRooms")) || [];

        // Format data for API
        const formattedRoomDetails = RoomDetailsRaw.map((room) => ({
          RatePlanID: room.selectedMealPlan?.RatePlanID,
          TotalRoom: room.quantity,
          RoomID: room.RoomID,
          Adults: room.adults,
          Child: room.children,
        }));



        const result = await agentPreBooking({
          PropertyID,
          CheckIn,
          CheckOut,
          RoomDetails: formattedRoomDetails,
        });



        localStorage.setItem("preBookingToken", result.RoomDetails[0]?.PreBookingToken);



        const mergedRooms = result.RoomDetails.map((room, index) => {
          const rate = result.RatePlan[index];
          return {
            ...room,
            TotalRoom: rate?.TotalRoom || 1,
            RoomRate: rate?.RoomRate || 0,
            RatePlan: rate?.RatePlan || "N/A",
            ExtraBedRate: rate?.ExtraBedCharges || 0,
          };
        });

        setRoomDetails(mergedRooms);

        // Price summary
        const totalRoomRate = result.RatePlan.reduce((sum, r) => sum + r.RoomRate, 0);
        const extraBedCharges = result.RatePlan.reduce((sum, r) => sum + r.ExtraBedCharges, 0);
        const totalAmount = totalRoomRate + extraBedCharges;
        const taxRate = result.TaxDetails[0]?.Tax || 0;
        const taxAmount = (totalRoomRate * taxRate) / 100;
        const totalAfterTax = totalAmount + taxAmount;

        setPriceSummary({
          checkInDate: CheckIn,
          checkOutDate: CheckOut,
          roomRate: totalRoomRate,
          extraBedCharges,
          totalAmount,
          tax: taxRate,
          taxAmount,
          totalAfterTax,
        });

      } catch (error) {
        console.error("Error fetching pre booking", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPreBookingData();
  }, []);


  useEffect(() => {
    if (roomDetails.length === 0) return;

    let totalRoomRate = roomDetails.reduce((sum, room) => sum + room.RoomRate, 0);
    let extraBedCharges = 0;

    roomDetails.forEach((room, idx) => {
      const bedCount = extraBeds[idx] || 0;
      const bedRate = room.ExtraBedRate || 0;
      extraBedCharges += bedCount * bedRate;
    });

    const totalAmount = totalRoomRate + extraBedCharges;


    setPriceSummary((prev) => ({
      ...prev,
      roomRate: totalRoomRate,
      extraBedCharges,
      totalAmount,
    }));
  }, [extraBeds, roomDetails]);


  // submit Guest details

  const [formData, setFormData] = useState({
    Title: "Mr.",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    EmailAddress: "",
    MobileNumber: "",
    Address: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("preBookingToken");
    if (token) {
      fetchAgentGuestDetail(token).then((res) => {
        if (res) {
          setFormData({
            Title: res.Title || "",
            FirstName: res.FirstName || "",
            MiddleName: res.MiddleName || "",
            LastName: res.LastName || "",
            EmailAddress: res.EmailAddress || "",
            MobileNumber: res.MobileNumber || "",
            Address: res.Address || "",
          });
          setSelectedCountry(res.Country || "");
          setSelectedState(res.State || "");
          setSelectedCity(res.City || "");
          if (res.Country) setStates(State.getStatesOfCountry(res.Country));
          if (res.State) setCities(City.getCitiesOfState(res.Country, res.State));
        }
      });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    setStates(State.getStatesOfCountry(countryCode));
    setSelectedState("");
    setCities([]);
    setSelectedCity("");
  };

  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    setSelectedState(stateCode);
    setCities(City.getCitiesOfState(selectedCountry, stateCode));
    setSelectedCity("");
  };

  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
  };


  const handleGuestSubmit = async () => {
    const PreBookingToken = localStorage.getItem("preBookingToken");

    const dataToSend = {
      PreBookingToken,
      ...formData,
      Country: selectedCountry,
      State: selectedState,
      City: selectedCity,
    };

    try {
      setLoading(true);
      // console.log("Data sent to API:", dataToSend);
      const response = await agentsaveGuestdetail(dataToSend);
      // console.log("Response from saveGuestDetail API:", response);

      if (response?.PreBookingToken) {

        // swal("Guest details saved successfully!", {
        //   icon: "success",
        //   buttons: {
        //     confirm: {
        //       text: "OK",
        //       className: "btn btn-success",
        //     },
        //   },
        // });

        swal("Guest details saved successfully!", {
          icon: "success",
          buttons: false,
          timer: 2000
        });

        //  Save returned token
        localStorage.setItem("preBookingToken", response.PreBookingToken);

        // Now call the next API with the token
        await fetchAgentGuestDetail(response.PreBookingToken);

        const modal = window.bootstrap.Modal.getInstance(document.getElementById("Guest_details"))
          || new window.bootstrap.Modal(document.getElementById("Guest_details"));
        modal.hide();

      } else {
        swal("Failed to save guest details", {
          icon: "error",
          buttons: {
            confirm: {
              text: "OK",
              className: "btn btn-danger",
            },
          },
        });
      }
    } catch (error) {
      console.error("Guest details saving failed:", error);
      alert("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };


  // submit Company details
  const [companyformdata, setCompanyformData] = useState({
    RegistrationCompanyName: "",
    RegistrationCompanyAddress: "",
    RegistrationNumber: "",
  });


  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setCompanyformData({ ...companyformdata, [name]: value });
  };

  const handleCompanySubmit = async () => {
    const PreBookingToken = localStorage.getItem("preBookingToken"); // token from earlier step

    const CompanydataToSend = {
      PreBookingToken,
      ...companyformdata,

    };

    try {
      // console.log("Company Data sent to API:", CompanydataToSend);
      const response = await agentsaveCompanydetail(CompanydataToSend);
      // console.log("Response from Company Detail API:", response);

      if (response?.PreBookingToken) {
        alert("Company details saved successfully");

        const modal = window.bootstrap.Modal.getInstance(document.getElementById("Company_details"))
          || new window.bootstrap.Modal(document.getElementById("Company_details"));
        modal.hide();


      } else {
        alert("Failed to save Company details");
      }
    } catch (error) {
      console.error("Company details saving failed:", error);
      alert("Something went wrong!");
    }
  };



  // Booking Comment Save Data
  const [bookingCommentformdata, setBookingCommentFormdata] = useState({
    BookingComment: "",
  })

  const handleBookingCommentChange = (e) => {
    const { name, value } = e.target;
    setBookingCommentFormdata({ ...bookingCommentformdata, [name]: value });
  };

  const handleBookingCommentSubmit = async () => {
    const PreBookingToken = localStorage.getItem("preBookingToken");

    const CommentdataToSend = {
      PreBookingToken,
      ...bookingCommentformdata,

    };

    try {
      // console.log("Comment Data sent to API:", CommentdataToSend);
      const response = await agentsaveCompanydetail(CommentdataToSend);
      // console.log("Response from Comment Detail API:", response);

      if (response?.PreBookingToken) {
        alert("commment details saved successfully");

        const modal = window.bootstrap.Modal.getInstance(document.getElementById("Booking_Comment"))
          || new window.bootstrap.Modal(document.getElementById("Booking_Comment"));
        modal.hide();

      } else {
        alert("Failed to save comment details");
      }
    } catch (error) {
      console.error("booking comment details saving failed:", error);
      alert("Something went wrong!");
    }
  };


  // get Guest detail
  useEffect(() => {
    const token = localStorage.getItem("preBookingToken");
    if (token) {
      fetchAgentGuestDetail(token);
    }
  }, []);

  const fetchAgentGuestDetail = async (PreBookingToken) => {
    try {
      const response = await agentGuestdetail({ PreBookingToken });
      // console.log("Fetched guest details:", response);

      if (Array.isArray(response) && response.length > 0) {
        setGuestData(response[0]);
      } else {
        console.warn("No guest data found");
      }
    } catch (error) {
      console.error("Error fetching guest detail:", error);
    }
  };





  // Confirm Booking part
  const handleConfirmBookingsave = async () => {
    const PreBookingToken = localStorage.getItem("preBookingToken");


    if (!PreBookingToken || !priceSummary) {
      swal("Missing booking data!", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      return;
    }

    const ConfirmdataToSend = {
      PreBookingToken,
      TotalAfterTax: priceSummary.totalAfterTax,
    };

    // console.log("Booking data", ConfirmdataToSend);
    try {
      setLoading(true);

      const response = await agentPrebookingconfirmsave(ConfirmdataToSend);
      // console.log("Booking Confirmed Response:", response);

      //   if (response?.PaymentCallbackURL) {
      //   alert("Booking Confirmed Successfully!");

      //   // Set payment URL to iframe
      //   setPaymentUrl(response.PaymentCallbackURL);
      // } else {
      //   alert("Payment URL not found in response.");
      // }

      if (response?.PaymentCallbackURL) {
        swal("Booking Confirmed Successfully!", {
          icon: "success",
          buttons: false,
          timer: 2000,
        });
        setTimeout(() => {
          navigate(`/Agent/Payment?url=${encodeURIComponent(response.PaymentCallbackURL)}`);
        }, 2000);
      } else {
        swal("Payment URL not found in response.", {
          icon: "error",
          buttons: {
            confirm: {
              text: "OK",
              className: "btn btn-danger",
            },
          },
        });
      }

    } catch (error) {
      console.error("Booking confirmation failed:", error);
      swal("Something went wrong during booking confirmation.", {
        icon: "error",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-danger",
          },
        },
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      {loading && (<FullScreenLoader />)}

      <div className="wrapper">
        <AgentSidebar />
        <div className="main-panel">
          <AgentHeader />
          <div className="container">
            <div className="page-inner">

              <div className="text-end mb-3">
                <Link to="/Agent/rooms" className="btn btn-black btn-sm"><i className="fas fa-arrow-left me-2"></i>Back to Booking Room's</Link>
              </div>

              <div className="row">
                {/* Room Selection*/}
                <div className="col-12  col-md-7 ">
                  {roomDetails.length > 0 ? (
                    roomDetails.map((room, index) => (

                      <div key={index} className="card p-3 shadow-sm">
                        <div className="row g-3 align-items-start">
                          <div className="col-12 col-md-4">
                            <img
                              src="/assets/img/Bedroom Image.jpg"
                              alt="Room"
                              className="img-fluid rounded-2 w-100"
                              style={{ maxHeight: "180px", objectFit: "cover" }}
                            />
                          </div>

                          <div className="col-12 col-md-8 d-flex flex-column justify-content-between">
                            <div>
                              <h5 className="fw-bold mb-2">{room.RoomName}</h5>

                              <div className="d-flex flex-wrap gap-4 mb-3">
                                {/* Adults */}
                                <div>
                                  <label className="fw-semibold mb-1 d-block">Adults</label>
                                  <div className="hstack gap-2">

                                    <span className="fw-semibold">{room.Adults}</span>

                                  </div>
                                </div>

                                {/* Children */}
                                <div>
                                  <label className="fw-semibold mb-1 d-block">Children</label>
                                  <div className="hstack gap-2">

                                    <span className="fw-semibold">{room.Child}</span>

                                  </div>
                                </div>

                                <div>
                                  <label className="fw-semibold mb-1 d-block">Extra Bed's</label>
                                  <div className="hstack gap-2">
                                    <select
                                      className="form-select form-select-sm"
                                      value={extraBeds[index] || 0}
                                      onChange={(e) => {
                                        const selected = parseInt(e.target.value);
                                        setExtraBeds(prev => ({
                                          ...prev,
                                          [index]: selected
                                        }));
                                      }}
                                    >
                                      {[...Array(7)].map((_, i) => (
                                        <option key={i} value={i}>{i}</option>
                                      ))}
                                    </select>


                                  </div>
                                </div>
                              </div>

                              <div className="fw-bold">Plan : <span >{room.RatePlan || "N/A"}</span></div>
                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <div className="fw-bold">Total Rooms : {room.TotalRoom}</div>
                                <span className="fw-bold fs-5 ">₹ {room.RoomRate || "0"}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>Loading room details...</p>
                  )}


                </div>

                {/* imfomation */}
                <div className="col-md-5">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">
                        <h5 className="fw-bold"> Add Informations</h5>

                      </div>
                    </div>
                    <div className="card-body">
                      <div className="d-flex mb-2">
                        <button type="button" className="btn btn-sm btn-black waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#Guest_details"><i className="fas fa-pen me-1"></i> Guest Info</button>
                        <button type="button" className="btn btn-sm btn-black waves-effect waves-light mx-2" data-bs-toggle="modal" data-bs-target="#Company_details"><i className="fas fa-receipt me-1"></i> Company Info </button>
                        <button type="button" className="btn btn-sm btn-black waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#Booking_Comment"><i className="fas fa-comment-dots me-1"></i>Booking Comment </button>
                      </div>
                      {guestData && (
                        <>
                          <div className="fw-bold">
                            Guest Name: <span className="fw-normal text-dark mx-2">{guestData?.Title} {guestData?.FirstName} {guestData?.MiddleName} {guestData?.LastName}</span>
                          </div>
                          <div className="fw-bold">
                            Email: <span className="fw-normal text-dark mx-2">{guestData?.EmailAddress}</span>
                          </div>
                          <div className="fw-bold">
                            Phone No: <span className="fw-normal text-dark mx-2">{guestData?.MobileNumber}</span>
                          </div>
                          <div className="fw-bold">
                            Address: <span className="fw-normal text-dark mx-2">{guestData?.Address}</span>
                          </div>
                        </>
                      )}
                    </div>

                  </div>

                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">
                        <h5 className="fw-bold">Price Summary</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="fw-bold">Check-in  & Check-out </div>
                      <span className="highlight"> {priceSummary ? `${priceSummary.checkInDate}  To  ${priceSummary.checkOutDate}` : "Loading..."} </span>
                      <hr />
                      <div className="d-flex justify-content-between">
                        <div className="fw-bold">Room Rate:</div>
                        <span className="highlight">{priceSummary ? `₹ ${priceSummary.roomRate}` : "Loading..."}
                        </span>
                      </div>
                      <p> ( {roomDetails.length} Room x{" "}
                        {priceSummary
                          ? Math.ceil(
                            (new Date(priceSummary.checkOutDate) - new Date(priceSummary.checkInDate)) /
                            (1000 * 60 * 60 * 24)
                          )
                          : "?"}{" "}
                        Night )</p>

                      <div className="d-flex justify-content-between">
                        <div className="fw-bold">Extra Bed  ( {Object.values(extraBeds).reduce((sum, val) => sum + val, 0)} )</div>
                        <span className="highlight">{priceSummary ? `₹ ${priceSummary.extraBedCharges}` : "Loading..."}
                        </span>
                      </div>

                      <hr />

                      <div className="d-flex justify-content-between mt-2">
                        <div className="fw-bold">Total Payment</div>
                        <span className="highlight"> {priceSummary
                          ? `₹ ${priceSummary.totalAmount.toFixed(2)}` : "Loading..."}</span>
                      </div>

                      <hr />

                      <div className="d-flex justify-content-between mt-2">
                        <div className="fw-bold">Taxes & Fees:</div>
                        <span className="highlight"> {priceSummary ? `₹ ${priceSummary.taxAmount.toFixed(2)}` : "Loading..."} </span>
                      </div>
                      <hr />

                      <div className="d-flex justify-content-between">
                        <div className="fw-bold fs-5">Total After Tax</div>
                        <h4>{priceSummary ? `₹ ${priceSummary.totalAfterTax.toFixed(2)}` : "Loading..."}</h4>
                      </div>
                      <button className="btn btn-black w-100 mt-3" onClick={handleConfirmBookingsave} >Confirm Booking</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Guest Detail Modal */}
          <>
            <div
              id="Guest_details"
              className="modal fade"
              tabIndex={-1}
              role="dialog"
              aria-hidden="true"
              style={{ display: "none" }}
            >
              <div className="modal-dialog" style={{ maxWidth: "50rem" }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Guest Information</h4>

                  </div>
                  <div className="modal-body p-4">
                    <form onSubmit={handleGuestSubmit}>
                      <div className="row">
                        <div className="col-md-4 ">
                          <label className="form-label">Title</label>
                          <select name="Title" className="form-control form-select" value={formData.Title} onChange={handleChange} required>
                            <option value="">Select Title</option>
                            <option>Mr</option>
                            <option>Mrs</option>
                            <option>Ms</option>
                            <option>Miss</option>
                            <option>Dr</option>
                          </select>
                        </div>
                        <div className="col-md-4 mb-3 ">
                          <label className="form-label">First Name</label>
                          <input type="text" name="FirstName" className="form-control" placeholder="Enter First Name" value={formData.FirstName} onChange={handleChange} required />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Middle Name</label>
                          <input type="text" name="MiddleName" className="form-control" placeholder="Enter Middle Name" value={formData.MiddleName} onChange={handleChange} />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Last Name</label>
                          <input type="text" name="LastName" className="form-control" placeholder="Enter Last Name" value={formData.LastName} onChange={handleChange} required />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Email</label>
                          <input type="email" name="EmailAddress" className="form-control" placeholder="Enter Email" value={formData.EmailAddress} onChange={handleChange} required />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Mobile Number</label>
                          <input type="number" name="MobileNumber" className="form-control" placeholder="Enter Mobile No" value={formData.MobileNumber} onChange={handleChange} required />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Address</label>
                          <textarea name="Address" className="form-control" placeholder="Enter Address" value={formData.Address} onChange={handleChange} required />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label">Country</label>
                          <select
                            className="form-control form-select"
                            onChange={handleCountryChange}
                            value={selectedCountry}
                            required
                          >
                            <option value="">-- Select Country --</option>
                            {Country.getAllCountries().map((country) => (
                              <option key={country.isoCode} value={country.isoCode}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label">State</label>
                          <select
                            className="form-control form-select"
                            onChange={handleStateChange}
                            value={selectedState}
                            disabled={!states.length}
                            required
                          >
                            <option value="">-- Select State --</option>
                            {states.map((state) => (
                              <option key={state.isoCode} value={state.isoCode}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label">City</label>
                          <select
                            className="form-control form-select"
                            onChange={handleCityChange}
                            value={selectedCity}
                            disabled={!cities.length}
                          >
                            <option value="">-- Select City --</option>
                            {cities.map((city) => (
                              <option key={city.name} value={city.name}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button type="button"
                          className="btn btn-danger  waves-effect"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button type="submit"
                          className="btn btn-primary waves-effect waves-light"

                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
            {/* /.modal */}
          </>

          {/* Company Detail Modal */}
          <>
            <div
              id="Company_details"
              className="modal fade"
              tabIndex={-1}
              role="dialog"
              aria-hidden="true"
              style={{ display: "none" }}
            >
              <div className="modal-dialog" style={{ maxWidth: "35rem" }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Add Company Details (Optional)</h4>

                  </div>
                  <div className="modal-body p-4">
                    <form onSubmit={handleCompanySubmit}>
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Registered Company Name</label>
                          <input type="text" name="RegistrationCompanyName" className="form-control" placeholder="Enter Company Name" value={companyformdata.RegistrationCompanyName} onChange={handleCompanyChange} required />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Registered Company Address</label>
                          <textarea name="RegistrationCompanyAddress" className="form-control" placeholder="Enter Company Adderss" value={companyformdata.RegistrationCompanyAddress} onChange={handleCompanyChange} />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Registered Company Number</label>
                          <input type="number" name="RegistrationNumber" className="form-control" placeholder="Eneter Companny Number" value={companyformdata.RegistrationNumber} onChange={handleCompanyChange} />
                        </div>
                      </div>


                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger  waves-effect"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary waves-effect waves-light"

                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
            {/* /.modal */}
          </>


          {/* Booking Commment Modal */}
          <>
            <div
              id="Booking_Comment"
              className="modal fade"
              tabIndex={-1}
              role="dialog"
              aria-hidden="true"
              style={{ display: "none" }}
            >
              <div className="modal-dialog" style={{ maxWidth: "50rem" }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Add Booking Comment (optional)</h4>

                  </div>
                  <div className="modal-body p-4">
                    <form onSubmit={handleBookingCommentSubmit}>

                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <textarea className="form-control" placeholder="Enter Booking Comment" name="BookingComment" value={bookingCommentformdata.BookingComment} onChange={handleBookingCommentChange} required />
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger  waves-effect"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary waves-effect waves-light"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
            {/* /.modal */}
          </>
          {/* {paymentUrl && <PaymentIframe src={paymentUrl} />} */}

        </div>
        <ThemeSettings />
      </div>

    </>
  )
}
